module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.myprofile))]), _vm._v(" "), ((_vm.reverseTransformedEmail.toLowerCase().indexOf('cargill.') == -1 && _vm.reverseTransformedEmail.toLowerCase().indexOf('crgl-thirdparty.') == -1 && _vm.reverseTransformedEmail.toLowerCase().indexOf('awb.') == -1)) ? _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.enableEdit && (!_vm.isAzureUser || _vm.isServiceAccountGroupMember)),
      expression: "!enableEdit && (!isAzureUser || isServiceAccountGroupMember)"
    }],
    staticClass: "btn btn-primary adduser-btn",
    class: {
      disabled: _vm.isAzureUser && !_vm.isServiceAccountGroupMember
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editFields()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.edit))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nameUpdated),
      expression: "nameUpdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.nameUpdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nameUpdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pwdupdated),
      expression: "pwdupdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.pwdupdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.pwdupdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.QAupdated),
      expression: "QAupdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.QAupdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.QAupdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneupdated),
      expression: "phoneupdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.phoneupdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.phoneupdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activationpending),
      expression: "activationpending"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.activationpending = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationpending) + "\n\t\t  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "background": "#f1f1f1 !important",
      "margin-bottom": "10px",
      "padding": "14px 14px"
    }
  }, [_c('div', {
    staticClass: "user-creds"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.basicinfo) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.first_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.last_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.primary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reverseTransformedEmail),
      expression: "reverseTransformedEmail"
    }],
    staticClass: "form-control input-adduser disabled",
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.reverseTransformedEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reverseTransformedEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.secondary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserSecondaryEmail),
      expression: "addUserSecondaryEmail"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.addUserSecondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserSecondaryEmail = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    staticStyle: {
      "min-width": "initial"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.changepwd) + ":")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.passwordsec = !_vm.passwordsec
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordsec),
      expression: "passwordsec"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.oldpwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldpassword),
      expression: "oldpassword"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.oldpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.oldpassword.trim().length > 0),
      expression: "oldpassword.trim().length > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "sometext-hidden",
    staticStyle: {
      "color": "transparent",
      "width": "100%",
      "display": "block"
    }
  }, [_vm._v("sometext")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "btn btn-primary adduser-btn",
    class: {
      disabled: _vm.repeatpassword.length === 0 || _vm.password.length === 0 || _vm.oldpassword.length === 0
    },
    staticStyle: {
      "margin-left": "0px",
      "max-height": "34px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatePwd()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.update))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  }), _vm._v(" "), _vm._l((_vm.repeatPwdValidationObj), function(j) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(j))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.formValidationObj), function(k) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.enableEdit),
        expression: "enableEdit"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(k))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', [_c('label', {
    staticClass: "form-control-label",
    staticStyle: {
      "min-width": "initial"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nop) + ":")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.phnsec = !_vm.phnsec
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phnsec),
      expression: "phnsec"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent && !_vm.factorDeleted),
      expression: "!codeSent && !factorDeleted"
    }],
    staticClass: "wrap-input col-lg-4 col-md-4 col-sm-6 col-xs-12 donotedit",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control input-adduser disabled donotedit",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "tabindex": -1,
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent && !_vm.factorDeleted),
      expression: "!codeSent && !factorDeleted"
    }],
    staticClass: "wrap-input col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "btn btn-primary adduser-btn",
    staticStyle: {
      "margin-left": "0px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatePhone()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.update))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.factorStatus))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phnsec),
      expression: "phnsec"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.factorDeleted && !_vm.codeSent && _vm.enableEdit),
      expression: "factorDeleted && !codeSent && enableEdit"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('div', [_c('span', {
    attrs: {
      "for": "countryCode"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.country))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.country_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countryCode),
      expression: "countryCode"
    }],
    staticStyle: {
      "width": "100%",
      "padding": "0px 10px !important"
    },
    attrs: {
      "id": "countryCode",
      "name": "countryCode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "93"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['93']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "355"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['355']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "213"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['213']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1684"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1684']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "376"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['376']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "244"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['244']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1264"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1264']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0672"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['antar']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1268"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1268']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "54"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['54']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "374"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['374']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "297"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['297']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "061"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['aus']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "43"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['43']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "994"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['994']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1242"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1242']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "973"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['973']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "880"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['880']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1246"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1246']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "375"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['375']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['32']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "501"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['501']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "229"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['229']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1441"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1441']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "975"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['975']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "591"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['591']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "387"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['387']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "267"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['267']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "55"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['55']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "246"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['246']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "673"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['673']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "359"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['359']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "226"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['226']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "257"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['257']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "855"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['855']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "237"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['237']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['can']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "238"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['238']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1345"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1345']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "236"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['236']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "235"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['235']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "56"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['56']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "86"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['86']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['61']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "57"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['57']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "269"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['269']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "242"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['242']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "243"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['243']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "682"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['682']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "506"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['506']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "385"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['385']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "53"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['53']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "357"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['357']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "420"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['420']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['45']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "253"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['253']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1767"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1767']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1809"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1809']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "593"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['593']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['20']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "503"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['503']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "240"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['240']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "291"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['291']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "372"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['372']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "251"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['251']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0500"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['falk']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "298"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['298']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "679"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['679']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "358"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['358']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "33"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['33']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "689"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['689']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "241"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['241']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "220"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['220']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "995"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['995']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['49']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "233"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['233']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "350"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['350']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['30']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "299"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['299']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1473"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1473']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "590"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['590']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1671"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1671']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "502"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['502']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "441481"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['441481']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "224"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['224']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "245"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['245']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "592"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['592']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "509"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['509']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "379"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['379']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "504"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['504']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "852"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['852']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "36"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['36']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "354"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['354']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "91"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['91']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "62"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['62']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "98"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['98']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "964"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['964']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "353"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['353']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "972"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['972']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "39"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['39']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "225"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['225']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1876"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1876']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "81"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['81']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "441534"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['441534']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "962"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['962']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['kazak']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "254"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['254']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "686"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['686']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "850"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['850']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "82"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['82']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "965"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['965']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "996"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['996']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "856"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['856']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "371"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['371']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "961"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['961']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "266"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['266']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "231"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['231']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "218"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['218']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "423"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['423']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "370"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['370']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "352"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['352']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "853"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['853']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "389"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['389']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "261"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['261']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "265"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['265']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['60']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "960"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['960']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "223"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['223']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "356"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['356']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "692"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['692']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "596"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['596']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "222"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['222']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "230"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['230']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0262"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['mayotte']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "52"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['52']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "691"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['691']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "373"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['373']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "377"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['377']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "976"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['976']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "382"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['382']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1664"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1664']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0212"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['morocco']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "258"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['258']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "95"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['95']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "264"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['264']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "674"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['674']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "977"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['977']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['31']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "599"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['599']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "687"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['687']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "64"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['64']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "505"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['505']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "227"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['227']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "234"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['234']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "683"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['683']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "672"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['672']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1670"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1670']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "047"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['norway']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "968"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['968']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['92']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "680"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['680']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "970"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['970']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "507"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['507']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "675"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['675']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "595"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['595']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['51']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "63"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['63']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "064"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['pitcairn']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['48']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "351"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['351']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1787"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1787']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "974"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['974']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "262"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['262']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['40']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['7']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "250"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['250']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "290"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['290']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1869"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1869']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1758"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1758']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "508"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['508']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1784"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1784']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "685"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['685']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "378"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['378']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "239"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['239']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "966"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['966']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "221"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['221']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "381"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['381']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "248"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['248']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "232"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['232']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "65"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['65']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "421"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['421']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "386"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['386']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "677"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['677']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "252"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['252']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "27"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['27']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['500']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "211"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['211']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "34"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['34']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "94"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['94']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "249"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['249']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "597"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['597']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "47"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['47']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "268"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['268']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "46"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['46']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['41']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "963"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['963']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "886"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['886']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "992"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['992']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "255"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['255']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "66"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['66']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "670"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['670']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "228"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['228']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "690"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['690']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "676"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['676']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1868"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1868']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "216"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['216']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['90']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "993"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['993']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1649"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1649']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "688"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['688']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "256"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['256']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "380"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['380']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "971"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['971']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "44"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['44']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "598"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['598']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "998"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['998']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "678"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['678']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "58"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['58']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "84"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['84']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1284"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1284']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1340"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1340']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "681"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['681']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "212"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['212']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "967"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['967']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "260"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['260']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "263"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['263']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {}, [_c('span', {
    attrs: {
      "for": "phN"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nop))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.nop_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phN),
      expression: "phN"
    }],
    staticStyle: {
      "width": "100%",
      "-webkit-user-select": "auto !important"
    },
    attrs: {
      "type": "text",
      "id": "pn",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.phN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phN = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('span', {
    staticClass: "sometext-hidden",
    staticStyle: {
      "color": "transparent",
      "width": "100%",
      "display": "block"
    }
  }, [_vm._v("sometext")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent),
      expression: "!codeSent"
    }],
    staticClass: "btn btn-primary adduser-btn",
    class: {
      disabled: !_vm.phN.trim().length
    },
    staticStyle: {
      "padding": "14px 23px",
      "background": "#f9f9f9",
      "color": "#595959",
      "border": "1px solid #c3c3c3",
      "font-size": "12px",
      "height": "30px",
      "margin-left": "0px !important"
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.update))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNumberNotValid == true),
      expression: "phoneNumberNotValid == true"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.user_lang.phonenumberinvalid))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "color": "#a7a7a7",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code_rule))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "m-form verify-code-form clearfix leave-open-on-success",
    staticStyle: {
      "padding": "0px 15px",
      "margin": "0px -15px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.edit.form"
    }
  }, [_c('input', {
    staticClass: "hide",
    attrs: {
      "type": "hidden",
      "name": "_xsrfToken",
      "value": "bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "smsFactor",
      "value": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hide",
    attrs: {
      "name": "activateFactor",
      "value": "false",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin-btm-0",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "smsPhoneCodeForm.code.label",
      "for": "verifyCode",
      "path": "token",
      "csserrorclass": "error"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code) + "\n\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifycode),
      expression: "verifycode"
    }],
    staticClass: "verify-code",
    staticStyle: {
      "visibility": "inherit",
      "position": "inherit",
      "max-width": "200px !important",
      "display": "inline-block !important",
      "padding-top": "14px"
    },
    attrs: {
      "id": "verifyCode",
      "name": "code",
      "type": "text",
      "value": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.verifycode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifycode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "codeVerifybtn",
    class: {
      disabled: _vm.verifycode.trim().length === 0
    },
    on: {
      "click": function($event) {
        _vm.verifySMS()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.verify))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "codeVerifybtn",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.back))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passCodeInvalid),
      expression: "passCodeInvalid"
    }],
    attrs: {
      "id": "smsPhoneCodeForm.edit.errors"
    }
  }, [_c('div', {
    staticClass: "error",
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.passcodeNotValid))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticClass: "error",
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptypasscode == true),
      expression: "emptypasscode == true"
    }],
    staticClass: "error",
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.emptypasscode))])]), _vm._v(" "), _vm._l((_vm.phoneValidationObj), function(j) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.enableEdit),
        expression: "enableEdit"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(j))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.QAValidationObj), function(k) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.enableEdit && _vm.secqsec),
        expression: "enableEdit && secqsec"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(k))])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticStyle: {
      "margin-top": "10px",
      "width": "100%",
      "margin-right": "15px",
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary adduser-btn",
    staticStyle: {
      "margin-left": "845px",
      "max-height": "34px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateName()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.update))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "padding": "8px 20px"
    },
    on: {
      "click": function($event) {
        _vm.enableEdit = false, _vm.clearAllFieldsandValidations()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cancel))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['assignedapps']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-top": "5px",
      "padding-right": "0px"
    }
  }, _vm._l((_vm.regApps), function(i) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps",
      attrs: {
        "title": i.label
      },
      on: {
        "click": function($event) {
          _vm.goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)
        }
      }
    }, [_c('div', {
      staticClass: "icon-wrap"
    }, [_c('img', {
      staticStyle: {
        "height": "34px"
      },
      attrs: {
        "src": i._links.logo[0].href
      }
    })]), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(i.label))])])
  }))])])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a8c026c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a8c026c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/MyProfile.vue
// module id = 717
// module chunks = 1